import {Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, Self} from '@angular/core';
import {ControlValueAccessor, NgControl} from '@angular/forms';

@Component({
  selector: 'carbon-input',
  templateUrl: './carbon-input.component.html',
  styleUrls: ['./carbon-input.component.css'],
})
export class CarbonInputComponent implements OnInit, ControlValueAccessor, OnDestroy {
  @Input() id: string;
  @Input() label: string;
  @Input() type: string;
  @Input() require: boolean;
  @Input() readonly: boolean;
  @Input() maxlength: number = 255;
  @Input() placeholder: string = '';
  @Input() isExternalInvalid: boolean = false;

  @Output() blurEvent = new EventEmitter<FocusEvent>();
  @Output() keyupEvent = new EventEmitter<KeyboardEvent>();

  value = '';

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get control() {
    return this.ngControl ? this.ngControl.control : null;
  }

  get isInvalid(): boolean {
    return (!!this.control && this.control.invalid && (this.control.dirty || this.control.touched)) || this.isExternalInvalid;
  }

  get isValid(): boolean {
    return !!this.control && this.control.valid && this.control.value !== '' && (this.control.dirty || this.control.touched) && !this.isExternalInvalid;
  }

  get errorMessage(): string {
    if (!this.control || !this.control.errors) return '';

    if (this.control.errors['required']) return 'Campo obrigatório';
    if (this.control.errors['email']) return 'Email inválido';
    if (this.control.errors['minlength']) return 'Texto muito curto';
    if (this.control.errors['maxlength']) return 'Texto muito longo';

    return 'Valor inválido';
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    if (this.control) {
      this.control.reset(null);
      this.control.setErrors(null);
      this.control.markAsPristine();
      this.control.markAsUntouched();
      this.control.updateValueAndValidity();
    }
  }


  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.value = value;
    this.onChange(value);
  }

  onBlur(event: FocusEvent) {
    this.onTouched();
    this.blurEvent.emit(event);
  }

  onKeyup(event: KeyboardEvent) {
    this.keyupEvent.emit(event);
  }


}
